import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const isNativePlatform = (): boolean => Capacitor.isNativePlatform();

// Custom URL scheme registered in ios/App/App/Info.plist. Overridable so a
// universal link (https) can be swapped in if Suunto rejects custom schemes.
const NATIVE_REDIRECT_URI =
  process.env.REACT_APP_NATIVE_REDIRECT_URI || 'achievementscuba://auth/callback';

// Inside the app window.location.origin is capacitor://localhost, which Suunto
// can't redirect back to, so native uses the registered scheme instead.
export const getSuuntoRedirectUri = (): string =>
  isNativePlatform() ? NATIVE_REDIRECT_URI : `${window.location.origin}/auth/callback`;

export const isNativeAuthCallbackUrl = (url: string): boolean =>
  url.startsWith(NATIVE_REDIRECT_URI);

// On native, an in-app browser sheet keeps the WebView (and its state) alive;
// navigating the WebView to Suunto would lose the app shell.
export const openAuthUrl = async (url: string): Promise<void> => {
  if (isNativePlatform()) {
    await Browser.open({ url });
  } else {
    window.location.href = url;
  }
};

export const closeAuthBrowser = async (): Promise<void> => {
  if (isNativePlatform()) {
    try {
      await Browser.close();
    } catch {
      // Already dismissed by the user.
    }
  }
};
